export default "__VITE_ASSET__vtpe889n__"